import React, { useState } from 'react';
import styles from './Components/CSS/AudioSeriesVast.module.css';
import { CirclePlayIcon,} from 'lucide-react';
import { imageData } from './Components/AudioSeriesVast2';

function AudioSeriesVast() {
  const [activeId, setActiveId] = useState(null);

  const handleItemClick = (id) => {
    setActiveId(id === activeId ? null : id);
  };

  return (
    <div>
      <div className={styles.heroBanner}>
        <div className={styles.heroContent}>
          <div className={styles.contentWrapper}>
            <h1 className={styles.title}>Harry Potter</h1>
            <div>
              <p className={styles.des}>To be firmly fixed or bound, or to be tightly shut.
                 For example, you might describe a clock as fast if it indicates a time ahead of the correct time,
                accomplish something in a short time, or to last a short time. For example, you might describe a visit or work as fast,
                you might describe a clock as fast if it indicates a time ahead of the correct time,accomplish something in a short time, or to last a short time. For example, you might describe a visit or work as fast.  </p>
            </div>
            <div className={styles.metaInfo}>
              <span>Audio</span>
              <span className={styles.separator}>|</span>
              <span>13 Episodes</span>
              <span className={styles.separator}>|</span>
              <span>Thriller</span>
            </div>
            <button className={styles.listenButton}>
              <span className={styles.playIcon}>▶</span>
              Listen Now
            </button>
          </div>
        </div>
      </div>
      <div className={styles.gridDiv} style={{ marginTop: '4rem' }}>
        {imageData.map((item) => (
          <div 
            className={`${styles.container} ${item.id === activeId ? styles.active : ''}`}
            key={item.id}
            onClick={() => handleItemClick(item.id)}
          >
            <div className={styles.imgDiv}>
              <img
                src={item.image}
                alt={item.title}
                width={150}
                height={250}
              />
            </div>
            <div className={styles.outerText}>
              <span><CirclePlayIcon size={48} className={styles.hov} color="#ffffff"/></span>
              <h3>{item.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AudioSeriesVast;